import React, { createContext, useContext } from 'react'

/** Bumped by the dashboard interval refresh so period hooks refetch in place. */
const DashboardRefreshContext = createContext(0)

export function DashboardRefreshProvider({
  refreshKey,
  children,
}: {
  refreshKey: number
  children: React.ReactNode
}): React.ReactElement {
  return (
    <DashboardRefreshContext.Provider value={refreshKey}>
      {children}
    </DashboardRefreshContext.Provider>
  )
}

export function useDashboardRefreshKey(): number {
  return useContext(DashboardRefreshContext)
}
